import {
  Image,
  Text,
  Box,
  Button,
  Heading,
  Flex,
  Stack,
  SimpleGrid,
} from "@chakra-ui/react";
import React from "react";
import Banner from "../components/becomeSeller/Banner";
import BuyerStories from "../components/becomeSeller/BuyerStories";
import JoinOurGrowingSection from "../components/becomeSeller/JoinOurGrowingSection";
import CommonContainer from "../components/shared/CommonContainer";
import QASection from "../components/becomeSeller/QASection";

export default function BecomeSellerPage() {
  return (
    <>
      <Banner />
      <CommonContainer>
        <JoinOurGrowingSection />
      </CommonContainer>
      <Flex bg={{ base: "#f7f7f7", md: "white" }}>
        <CommonContainer>
          <Stack alignItems="center" my={10}>
            <Heading
              fontWeight={"semibold"}
              fontSize={{ base: "24px", md: "31px" }}
              py={10}
            >
              How it Works
            </Heading>
            <SimpleGrid
              columns={{ md: 3 }}
              gap={{ base: 10, xl: 10 }}
              width={{ lg: "80%" }}
              py={{ md: 10 }}
            >
              {howItWorksData.map((item, index) => (
                <Stack
                  alignItems="center"
                  justifyContent="space-between"
                  key={index}
                  maxW="320px"
                >
                  <Box height={{ md: "120px" }}>
                    <Image src={item.imageUrl} />
                  </Box>
                  <Heading
                    fontWeight={"semibold"}
                    fontSize={{ base: "17px", xl: "22px" }}
                    textAlign={"center"}
                  >
                    {item.title}
                  </Heading>
                  <Text
                    color={"#727272"}
                    textAlign={"center"}
                    fontSize={{ base: "14px", xl: "18px" }}
                    fontWeight={"medium"}
                    w="80%"
                  >
                    {item.description}
                  </Text>
                </Stack>
              ))}
            </SimpleGrid>
          </Stack>
        </CommonContainer>
      </Flex>
      <CommonContainer>
        <BuyerStories />
      </CommonContainer>
      <QASection />
      <Stack gap={10} alignItems="center" py={20}>
        <Text fontWeight={"semibold"} color="gray.500">
          Sign up and create your first Gig today
        </Text>
        <Box>
          <Button bg="brand.500" width="200px" color="white" borderRadius={10}>
            Get Started
          </Button>
        </Box>
      </Stack>
    </>
  );
}

const howItWorksData = [
  {
    title: "1. Create a Gig",
    description: "sit amet, consectetur adipscing elit",
    imageUrl: "/images/become-a-seller/gig.png",
  },
  {
    title: "2. Deliver Great Work",
    description: "sit amet, consectetur adipscing elit",
    imageUrl: "/images/become-a-seller/work.png",
  },
  {
    title: "3. Get a Paid",
    description: "sit amet, consectetur adipscing elit ",
    imageUrl: "/images/become-a-seller/paid.png",
  },
];
